<template>
    <div :class="classes">
        <label
            :for="inputId"
            class="c-form__label"
        >
            {{ label }}
        </label>

        <input
            :id="inputId"
            :type="type"
            :name="name"
            :required="requiredAttr"
            :value="value"
            :data-autocomplete-name="dataAutocompleteName"
            class="c-form__input"
        />
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'text'
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        },
        dataAutocompleteName: {
            type: String,
            default: ''
        }
    },
    computed: {
        requiredAttr() {
            return this.isRequired ? 'required' : false;
        },
        inputId() {
            return `reservation-${this.name}`;
        },
        classes() {
            let classes = 'c-form__item c-form__item__text'

            if (this.isRequired) {
                classes += ' is-required'
            }

            return classes
        }
    }
}
</script>